import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Loader from "./Loader";


export default function Auth({ children }) {
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const simulateTokenVerification = () => {
    const token = localStorage.getItem("token");

    // Simulate an async operation
    setTimeout(() => {
      if (token) {
        setIsTokenValid(true);
      }
      setIsLoading(false);
    }, 1000); // Simulate a 1-second delay
  };

  useEffect(() => {
    simulateTokenVerification();
  });

  if (isLoading) {
    return <Loader />; // Or a loading spinner
  }

  if (isTokenValid) {
    return <>{children}</>;
  } else {
    return <Navigate to="/auth/login" />;
  }
}
